import { render, staticRenderFns } from "./ThirdPartyContract.vue?vue&type=template&id=4036ef34&"
import script from "./ThirdPartyContract.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports